
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import ExpertiseTeam from './components/ExpertiseTeam';
import ProjectsShowcase from './components/ProjectsShowcase';
import TechnicalCapabilities from './components/TechnicalCapabilities';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <AboutHero />
      <ExpertiseTeam />
      <TechnicalCapabilities />
      <ProjectsShowcase />
      <Footer />
    </div>
  );
};

export default About;
